<div class='edit-icon' [ngClass]="{ 'edit-active': isActive }">
    <img 
    src="https://img.icons8.com/material-two-tone/24/create-new--v2.png" 
    alt="edit-icon" />
</div>